import React from "react";
import "./LawnPackage.css";
import { Link } from "react-router-dom";

const LawnPackage = () => {
  return (
    <div className="Lawn-package-section">
      <h2 className="Lawn-package-title">
        Restore Your Commercial Grounds to Peak Condition
      </h2>

      <p className="Lawn-package-subtitle">
        If your landscape is not properly maintained, our Lawn Recovery Package
        can restore your property to its optimal condition. However, a cleanup
        or redesign may be needed first — "lawn recovery" is essentially just a
        fancy way of saying re-seeding a lawn.
      </p>

      <Link to="/Landscapingdesign" className="LawnPackageone-button">
        Check Packages
      </Link>
    </div>
  );
};

export default LawnPackage;
